import type { UserFields } from '@ms/yammer-graphql';

import type { UserOriginNetwork } from '../../../state/userOriginNetworks/types';

type ProcessOriginNetwork = (value: UserFields) => UserOriginNetwork;
export const processOriginNetwork: ProcessOriginNetwork = ({ id, originNetworkBadgeDisplayName, originNetworkId }) => ({
  id,
  badge: originNetworkBadgeDisplayName ?? undefined,
  originNetworkId: originNetworkId ?? undefined,
});
